import { ClientMethodsTypes, client } from '@/services/v2/client'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { ProfileQueryKeys } from 'containers/profile/types/query-keys'
import { useUser } from 'containers/user/hooks/useUser'
import { UserQueryKeys } from 'containers/user/types/user'

const endpointUrl = '/api/v1/users'

interface ImageUploadServiceProp {
  id?: string
  file: File
}

export const useHighlightImageUploader = () => {
  const queryClient = useQueryClient()
  const { user } = useUser()

  return useMutation({
    mutationFn: async ({ file, id = 'creating' }: ImageUploadServiceProp) => {
      const formData = new FormData()
      formData.append('file', file)
      return client<string>(`${endpointUrl}/highlight/image-upload/${id}`, {
        method: ClientMethodsTypes.POST,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        body: formData,
      })
    },
    onSuccess: async () => {
      await Promise.all([
        await queryClient.invalidateQueries([UserQueryKeys.USER]),
        await queryClient.invalidateQueries([
          ProfileQueryKeys.PROFILE,
          user?.username?.toLocaleLowerCase(),
        ]),
        await queryClient.invalidateQueries([ProfileQueryKeys.HIGHLIGHTS]),
      ])
    },
  })
}
